<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1">
        <el-input
          v-model="state.params.Params.Key"
          style="width: 15%"
          placeholder="关键字"
          clearable
          @clear="
            delete state.params.Params.Key;
            onLoad();
          "
        ></el-input>
        <el-dropdown
          split-button
          @click="onLoad"
          type="primary"
          style="margin-left: 10px"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.Order,
          order: state.params.Asc == false ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.PageIndex - 1) * state.params.PageSize + index + 1
          "
          align="center"
        />
        <el-table-column
          sortable="Bh"
          label="状态/编号"
          width="160"
          :formatter="
            (row) => $tab_GroupFormat(row.DdZt?.Text, row.DdBh, row.DdZt?.Color)
          "
        />
        <el-table-column prop="Mc" sortable="Mc" label="名称/类型">
          <template #default="{ row }">
            <div style="text-align: left">
              <ul>
                {{
                  row.DdMc
                }}
              </ul>
              <ul style="font-size: 12px; line-height: 12px">
                {{
                  "[" + row.DdLx?.Text + "]" + row.DdTs + "天" + row.DdYs + "晚"
                }}
              </ul>
            </div>
          </template>
        </el-table-column>
        <el-table-column sortable="KhMc" label="客户">
          <template #default="{ row }">
            <div class="tab_doubleRow">
              <text>{{ row.DdKhMc }}</text>
              <br />
              <text>
                {{ "[" + row.DdKhMc + "]" + row.DdKhBh }}
              </text>
            </div></template
          >
        </el-table-column>
        <el-table-column prop="DdZrs" sortable="Zrs" label="人数" />
        <el-table-column
          prop="DdZje"
          sortable="DdZje"
          label="金额"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column
          prop="DdYsje"
          sortable="DdYsje"
          label="已收"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column
          prop="DdQkje"
          sortable="DdQkje"
          label="欠款"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column
          label="计调"
          :formatter="(row) => $tab_GroupFormat(row.DdJdyXm, row.DdJdyBmMc)"
        />
        <el-table-column
          prop="Cjsj"
          sortable="Cjsj"
          label="申请信息"
          width="160"
          :formatter="(row) => $tab_GroupFormat(row.CjrXm, row.Cjsj)"
        />
        <el-table-column
          label="操作"
          width="100"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Select"
              link
              @click="
                $store.commit('openMenu', {
                  path: 'LvYouDingDanFaTuanJiLuCheck',
                  title: '发团审核',
                  data: { id: row.Id },
                  refresh: true,
                })
              "
              >审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </ul>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.PageIndex"
      @onLoad="
        (pageIndex) => {
          state.params.PageIndex = pageIndex;
          onLoad();
        }
      "
    >
    </c_page>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { lvyoudingdanfatuanjilu_list } from "@/http/api";
import { useRouter } from "vue-router";

export default {
  components: {},
  setup() {
    const router = useRouter();
    const state = reactive({
      params: {
        PageSize: 20,
        PageIndex: 1,
        Params: {},
        Order: "Cjsj",
        Asc: false,
      },
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      lvyoudingdanfatuanjilu_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = (column) => {
      state.params.Order = column.prop;
      state.params.Asc = column.order === "ascending";
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, {
        params: {
          PageSize: 20,
          PageIndex: 1,
          Params: {},
          Order: "Cjsj",
          Asc: false,
        },
      });
      onLoad();
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      router,
    };
  },
};
</script>
<style lang="less" scoped>
.drawerCss {
  width: 40vw !important;
}

.drawerCss > div {
  overflow: hidden;
  padding: 0 !important;
}
</style>
